import * as React from 'react'

import {H1} from '@frontrow/console/src/components/typography'

import {type DistrictRosterCsvUrlsT} from '@frontrow/console/src/models/district-rosters-csv-urls'

type Props = {
  csvUrls: Array<DistrictRosterCsvUrlsT>
}

export function DistrictsRgpCsvs(props: Props): React.ReactElement {
  const {csvUrls} = props

  const row = (name: string, url: string) => (
    <tr>
      <td>{name}</td>
      <td>
        <a href={url} target="_blank">
          {url}
        </a>
      </td>
    </tr>
  )

  const tables = csvUrls.map((urls, i) => (
    <table key={i}>
      <thead>
        <th>CSV</th>
        <th>Link</th>
      </thead>
      {row('Academic Sessions', urls.academicSessionsUrl)}
      {row('Classes', urls.classesUrl)}
      {row('Courses', urls.coursesUrl)}
      {row('Demographics', urls.demographicsUrl)}
      {row('Enrollments', urls.enrollmentsUrl)}
      {row('Manifest', urls.manifestUrl)}
      {row('Orgs', urls.orgsUrl)}
      {row('Users', urls.usersUrl)}
    </table>
  ))

  return (
    <>
      <H1>RGP CSVs</H1>
      {tables}
    </>
  )
}
